import type { StaticLayerPayload } from "@config";
import { QrCodeLibrary } from "@library-elements/qr-code";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: QrCodeLibrary,
};

export const QrCode = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
